import {CartProduct} from './cart-product/CartProduct';
import {FormattedNumber} from '../../common/ui/FormattedNumber';
import {onDemandAmount, onDemandUnits, servedUnits} from '../domain/onDemandSplit';

/**
 * Zona "Bajo pedido" del carrito: reúne las unidades de productos bypass que
 * exceden el stock. Si se piden 23 y hay 22, arriba van las 22 con el resto
 * del pedido y aquí abajo la unidad restante. Las líneas bypass enteramente
 * sin stock salen aquí completas, con sus botones.
 *
 * Estas unidades NO cuentan para el pedido mínimo del envío gratuito (el
 * descuento se aplica en OrderRecap con onDemandAmount).
 */
export const OnDemandZoneUI = ({products = []}) => {
    const fullLines = products.filter((product) => onDemandUnits(product) > 0 && servedUnits(product) <= 0);
    const partialLines = products.filter((product) => onDemandUnits(product) > 0 && servedUnits(product) > 0);

    if (fullLines.length === 0 && partialLines.length === 0) {
        return null;
    }

    return (
        <div className="mt-4">
            <h4>Productos Bajo Pedido</h4>
            <small className="text-muted d-block mb-2">
                De estas unidades no tenemos stock ahora mismo: las pediremos al fabricante y te
                llamaremos cuando estén disponibles. <strong>No cuentan para el pedido mínimo.</strong>
            </small>
            <div className="d-flex flex-column gap-2">
                {fullLines.map((product) => (
                    <CartProduct key={product.id} product={product} />
                ))}
                {partialLines.map((product) => (
                    <div key={product.id} className="card">
                        <div className="card-body d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
                            <div className="d-grid">
                                <span>{product.name}</span>
                                <small className="text-muted">
                                    REF: {product.code} · {servedUnits(product) === 1
                                        ? 'la otra unidad va arriba'
                                        : `las otras ${servedUnits(product)} ud. van arriba`} con el resto del pedido
                                </small>
                            </div>
                            <div className="d-flex flex-row gap-4 text-center">
                                <div className="d-grid">
                                    <span>Unidades</span>
                                    <span className="text-danger">{onDemandUnits(product)}</span>
                                </div>
                                <div className="d-grid">
                                    <span>Sub total (Sin IVA)</span>
                                    <FormattedNumber value={product.sellingPrice * onDemandUnits(product)}
                                        config={{style: 'currency'}} />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="d-flex justify-content-end mt-2">
                <small className="text-muted">
                    Total bajo pedido (Sin IVA):&nbsp;
                    <FormattedNumber value={onDemandAmount(products)} config={{style: 'currency'}} />
                </small>
            </div>
        </div>
    );
};
